import { deleteFileUpload } from "./utils";
export const fileUpload = { util: { deleteFileUpload } };

// components/FileUpload/index.ts
export { FileUpload } from "./FileUpload";

// constants
export { FILE_UPLOAD_TYPES } from "./constants/fileUploadTypes";

// types that consumers may need
export type { UploadedFile } from "./types/UploadedFile.type";
export { UploadStatus } from "./types/UploadStatus.type";
